module.exports = __webpack_public_path__ + "img/wel-bg1.43b03d37.jpg";